import classNames from 'classnames';
import { Button } from 'components/atoms/Button';
import AIIcon from 'components/atoms/SVG/sidebarIcons/AIIcon.component';
import Bankicon from 'components/atoms/SVG/sidebarIcons/BankIcon.component';
import ExpensesIcon from 'components/atoms/SVG/sidebarIcons/ExpensesIcon.component';
import RevenuesIcon from 'components/atoms/SVG/sidebarIcons/RevenuesIcon.component';
import TaxesIcon from 'components/atoms/SVG/sidebarIcons/TaxesIcon.component';
import { Title } from 'components/atoms/Title';
import { SizesEnum } from 'components/atoms/Title/Title.enum';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { mobileAppLink } from 'utils/constants';
import globalModalsController from '../GlobalModalsService/globalModalsController';

type TabItem = {
  id: string;
  title: string;
  path: string;
  Icon: any;
  isActive: boolean;
  iconActiveClassName?: string;
  textActiveClassName?: string;
};

const BottomTabs: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs: TabItem[] = [
    {
      id: 'bank',
      title: t('menu.bank'),
      path: '/banks',
      Icon: Bankicon,
      isActive: location.pathname.startsWith('/banks'),
      iconActiveClassName: 'text-bank-500',
      textActiveClassName: 'text-bank-500',
    },
    {
      id: 'revenues',
      title: t('menu.invoices'),
      path: '/revenues',
      Icon: RevenuesIcon,
      isActive: location.pathname.startsWith('/revenues'),
      iconActiveClassName: 'text-revenues-500',
      textActiveClassName: 'text-revenues-500',
    },
    {
      id: 'expenses',
      title: t('menu.expenses'),
      path: '/expenses',
      Icon: ExpensesIcon,
      isActive: location.pathname.startsWith('/expenses'),
      iconActiveClassName: 'text-expenses-500',
      textActiveClassName: 'text-expenses-500',
    },
    {
      id: 'taxes',
      title: t('menu.taxes'),
      path: '/taxes',
      Icon: TaxesIcon,
      isActive: location.pathname.startsWith('/taxes'),
      iconActiveClassName: 'text-taxes-500',
      textActiveClassName: 'text-taxes-500',
    },
    {
      id: 'tax-advisor',
      title: t('sidebar.support.ai.title'),
      path: '/assistant',
      Icon: AIIcon,
      isActive: location.pathname.startsWith('/assistant'),
      iconActiveClassName: 'text-ai-500',
      textActiveClassName: 'text-ai-500',
    },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 py-4">
      <div className="flex justify-around items-center h-16 px-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => {
              if (tab.id !== 'expenses') {
                return globalModalsController.openModal({
                  id: 'block-navigation',
                  render: () => (
                    <div>
                      <Title type={SizesEnum.h5}>
                        {t('mobile_app_alert.title')}
                      </Title>

                      <p className="mt-2">
                        {t('mobile_app_alert.description', {
                          universeTitle: tab.title,
                        })}
                      </p>

                      <Button
                        className="mt-4"
                        color="expenses"
                        onClick={() => {
                          window.location.href = mobileAppLink;
                        }}
                      >
                        {t('download_mobile_app_cta')}
                      </Button>
                    </div>
                  ),
                  options: {
                    color: 'expenses',
                    name: 'block-navigation',
                  },
                });
              }

              navigate(tab.path);
            }}
            className={classNames(
              'flex flex-col items-center justify-center flex-1 h-full min-w-0',
              'transition-colors duration-200 ease-in-out',
              {
                'text-gray-500 hover:text-gray-700': !tab.isActive,
              },
            )}
          >
            <tab.Icon
              className={classNames('w-10 h-10 mb-1', {
                [tab.iconActiveClassName || '']: tab.isActive,
                'text-gray-500': !tab.isActive,
              })}
            />
            <span
              className={classNames('font-medium truncate max-w-full', {
                [tab.textActiveClassName || '']: tab.isActive,
                'text-gray-500': !tab.isActive,
              })}
            >
              {tab.title}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomTabs;
